import { WarrantiesService } from './../../../shared/backend/clients/api/warranties.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { SessionService } from '@src/app/shared/services/session.service';

@Component({
    selector: 'app-edit-warranty',
    templateUrl: './edit-warranty.component.html',
    styleUrl: './edit-warranty.component.scss',
    host: {
        class: 'app-edit-warranty'
    },
    standalone: false
})
export class EditWarrantyComponent implements OnInit {

  currentDate: Date = new Date();
  companyIsPrepaired = false;

  warrantyId: number | undefined;
  warranty: any = {};

  public warrantyForm: FormGroup = this.fb.group({
    code: [''],
    itemId: [''],
    isActive: [null],
    isPrepaired: [null],
    activationDate: [null],
    endDate: [null]
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private session: SessionService,
    private warrantiesService: WarrantiesService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.getWarrantyId();
    this.initForm();
  }

  getWarrantyId() {
    this.route.params.subscribe(async params => {
      this.warrantyId = parseInt(params['warrantyId']);
      this.warranty = await firstValueFrom(this.warrantiesService.apiWarrantiesIdGet(this.warrantyId));
      this.initForm();

      this.session.currentCompanyData$.subscribe(company => {
          this.companyIsPrepaired = !!company?.isPrepaired;
      });
    })
  }

  initForm() {
    const activationDate = new Date(this.warranty.activationDate);
    const endDate = new Date(this.warranty.endDate);

    this.warrantyForm.controls['code'].setValue(this.warranty.code);
    this.warrantyForm.controls['itemId'].setValue(this.warranty.itemId);
    this.warrantyForm.controls['isActive'].setValue(this.warranty.isActive);
    this.warrantyForm.controls['isPrepaired'].setValue(this.warranty.isPrepaired ? 'true' : 'false');
    this.warrantyForm.controls['activationDate'].setValue(activationDate);
    this.warrantyForm.controls['endDate'].setValue(endDate);
  }

  submitForm() {
    if (this.warrantyForm.valid) {
      const payload = {
        code: this.warrantyForm.controls['code'].value,
        itemId: this.warrantyForm.controls['itemId'].value,
        isActive: this.warrantyForm.controls['isActive'].value,
        isPrepaired: this.warrantyForm.controls['isPrepaired'].value,
        activationDate: this.warrantyForm.controls['activationDate'].value,
        endDate: this.warrantyForm.controls['endDatemId'].value
      };

      this.router.navigate(['/warranties', this.warrantyId]);

    }
  }

}
